import { Pipe, PipeTransform } from '@angular/core';
import { IntentTopic } from 'src/app/shared/dto';


@Pipe({
    name: 'existingTopicsFilter',
    standalone: false
})
export class ExistingTopicsFilterPipe implements PipeTransform {
    transform(topics: IntentTopic[], searchValue: string): any {
        if (!searchValue?.length) {
            return topics;
        }
        const searchValueLowercase: string = searchValue.toLowerCase();
        return topics?.filter((topic: IntentTopic) => topic.topic_name.toLowerCase().includes(searchValueLowercase))
    }
}
